<div class="col-md-12">
    <!--<h2>BunnyCRM Notes</h2>-->
    <p>BunnyCRM Notes is a personal-usage product inside BunnyCRM — a place to maintain your own notes,
        personal or business-related, alongside the rest of your workspace. Notes are written in markdown,
        which keeps creating and managing them fast and flexible: format as you type, without fighting a
        rich-text toolbar. Notes can also stay linked to the record they're about, so context lives next to
        the contact, deal, or ticket it belongs to instead of being scattered across documents and chat
        threads. Notes are private to their creator — they are never shared with the rest of the workspace.
    </p>
    <h3>Key Features</h3>
    <ul>
        <li><strong>Personal Notes:</strong> Keep your own personal or business-related notes inside BunnyCRM, not just record-linked ones.</li>
        <li><strong>Markdown-Based:</strong> Notes are written in markdown, giving high flexibility and ease when creating and managing them.</li>
        <li><strong>Record-Linked Notes:</strong> Notes attach directly to contacts, deals, tickets, or accounts.</li>
        <li><strong>Private to You:</strong> Notes are creator-only; teammates can't see them.</li>
        <li><strong>Search:</strong> Find any note by contact, keyword, or date.</li>
    </ul>
</div>
